<ngx-file-drop
    dropZoneLabel="Arraste arquivos aqui"
    (onFileDrop)="getRowsFromFile($event)"
    [multiple]="multiple"
    accept=".xlsx, .xlsm"
    class="dropzone"
>
    <ng-template
        ngx-file-drop-content-tmp
        let-openFileSelector="openFileSelector"
    >
        <div class="dropzone__upload" (click)="openFileSelector()">
            <p class="dropzone__upload__text">
                Arraste os arquivos para cá
                <br />
                ou
                <br />
                <span>clique para procurar</span>
            </p>
        </div>
    </ng-template>
</ngx-file-drop>
<div class="files-name" *ngIf="fileName">
    <div
        class="file"
        *ngFor="let name of fileName; let i = index"
        [class.file--invalid]="
            multiple && getFileValidationStatus(i)?.valid === false
        "
    >
        <mb-icon
            [svgColor]="
                multiple && getFileValidationStatus(i)?.valid === false
                    ? '#E45275'
                    : '#49AE72'
            "
            [size]="'sm'"
            [icon]="'xlsx'"
        ></mb-icon>
        <span>{{ name }}</span>
        <span
            *ngIf="multiple && getFileValidationStatus(i)?.valid === false"
            class="file__error-label"
        >
            (erro de validação)
        </span>
        <mb-icon
            [svgColor]="'#E45275'"
            [size]="'sm'"
            [icon]="'close'"
            (click)="multiple ? removeFileByIndex(i) : removeFiles()"
        ></mb-icon>
    </div>
</div>
